<input type="text" numbersOnly [(ngModel)]="value" #input [allowDecimals]="allowDecimals" />
